import * as React from 'react';

import { LottieAnimation } from 'components/animation';
import { MediaQuery, useMediaQuery } from 'hooks/use-media-query';

import { LoyaltyLoadingAnimation } from '../loyalty-lottie-animations';

import { LoyaltyLoaderContainer } from './loyalty-loader.styled';

export const LoyaltyLoader = ({ className }: { className?: string }) => {
  const isDesktop = useMediaQuery(MediaQuery.Desktop);
  const defaultOptions = {
    animationData: LoyaltyLoadingAnimation,
    autoplay: true,
    loop: true,
  };
  return (
    <LoyaltyLoaderContainer data-testid="loyalty-loader" className={className}>
      <LottieAnimation
        ariaLabel="animation"
        options={defaultOptions}
        width={isDesktop ? 180 : 140}
      />
    </LoyaltyLoaderContainer>
  );
};
